import React from 'react';
import FormulaFieldProto from '../formula-proto';

export default function renderFormulaInFormNew(id, props) {
    return <FormulaFieldProto renderMode="form-new" id={id} {...props} />;
}